import { ComponentProps } from 'react';

import { FilesTable } from '@/react/docker/components/FilesTable';
import { useEnvironmentId } from '@/react/hooks/useEnvironmentId';

import { createPersistedStore } from '@@/datatables/types';
import { useTableState } from '@@/datatables/useTableState';

import { buildUrl } from '../../volumes/BrowseView/build-url';

const tableKey = 'host-browser';

const settingsStore = createPersistedStore(tableKey, {
  desc: true,
  id: 'Dir',
});

interface Props
  extends Omit<
    ComponentProps<typeof FilesTable>,
    'isUploadAllowed' | 'tableState' | 'title' | 'getDownloadLink'
  > {
  relativePath: string;
}

export function AgentHostBrowser({
  relativePath,
  dataset,
  isRoot,
  onBrowse,
  onDelete,

  onFileSelectedForUpload,
  onGoToParent,
  onRename,
}: Props) {
  const envId = useEnvironmentId();
  const tableState = useTableState(settingsStore, tableKey);

  return (
    <FilesTable
      tableState={tableState}
      dataset={dataset}
      title={`Host browser - ${relativePath}`}
      isRoot={isRoot}
      onRename={onRename}
      onBrowse={onBrowse}
      getDownloadLink={(fileName) =>
        `/api${buildUrl({
          envId,
          action: 'get',
        })}?path=${fileName}`
      }
      onDelete={onDelete}
      isUploadAllowed
      onFileSelectedForUpload={onFileSelectedForUpload}
      onGoToParent={onGoToParent}
    />
  );
}
